<div *ngIf="(MyType==1 || MyType==2) && Switch_Alert_Form=='Hidden'">
  <div class="row">

    <div class="col-xl-4 mb-30">
      <div class="card card-statistics h-100">
        <div class="p-4 text-center bg-danger">
          <h5 class="mb-70 text-white">پروفایل</h5>
        </div>
        <div class="card-body text-center">
          <div class="avatar-top">
            <img class="img-fluid w-25 rounded-circle " src="{{BaserUrlImage}}" alt="">
          </div>
          <h3 class="mt-30">{{Fullname}}</h3>
          <h5 class="mt-30">{{Semat}} {{Almat_Ekhtesari}}</h5>
          <div class="table-responsive">
            <table class="mb-0 table table-bordered table-3 text-center table-striped">
              <thead style="background-color: #580009; color: white;">
                <tr>
                  <th>#</th>
                  <th>تاریخ ورود</th>
                  <th>مرورگر</th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of DataList_Browser">
                  <td>{{DataList_Browser.indexOf(item)+1}}</td>
                  <td>{{item.title}}</td>
                  <td>
                    <i *ngIf="item.code=='edge'" class="fa fa-edge"></i>
                    <i *ngIf="item.code=='firefox'" class="fa fa-firefox"></i>
                    <i *ngIf="item.code=='chrome'" class="fa fa-chrome"></i>
                    <i *ngIf="item.code=='safari'" class="fa fa-safari"></i>
                    <i *ngIf="item.code=='opera'" class="fa fa-opera"></i>
                    <i *ngIf="item.code=='opera'" class="fa fa-opera"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="divider mt-20"></div>
          <button (click)="set_Switch_Alert_Form('List')" type="button" class="btn btn-danger"><i
              class="fa fa-inbox"></i> صندوق پیام </button>
        </div>
      </div>
    </div>

    <div class="col-xl-8 mb-30">

      <div class="card card-statistics" style="margin-top: 5px;">
        <div class="card-body">
          <div class="tab nav-border" style="position: relative;">
            <div class="d-block d-md-flex justify-content-between">
              <div class="d-block w-100">
                <h5 class="card-title">
                  <span *ngIf="Type_ExpertDashboard==0">گزارش کالیراسیون ماه جاری</span>
                  <span *ngIf="Type_ExpertDashboard==1">گزارش کالیراسیون ماه گذشته</span>
                </h5>
              </div>
              <div class="d-block d-md-flex nav-tabs-custom">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active show" style="cursor: pointer;" (click)="set_Type_ExpertDashboard(1)"
                      *ngIf="Type_ExpertDashboard==0"> ماه گذشته </a>
                    <a class="nav-link active show" style="cursor: pointer;" (click)="set_Type_ExpertDashboard(0)"
                      *ngIf="Type_ExpertDashboard==1"> ماه جاری </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="tab-content">
              <div class="tab-pane fade active show">

                <div class="row mb-30">
                  <div class="col-md-4">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-info rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-wpforms highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark"> تعداد ماموریت </p>
                            <h5>{{mission}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-danger rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-file-powerpoint-o highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark"> امتیاز روز </p>
                            <h5 style="direction: ltr;">{{month_day_point}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-warning rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-file-powerpoint-o highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark"> امتیاز T4 </p>
                            <h5 style="direction: ltr;">{{month_point}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>

                <div class="row mb-30">

                  <div class="col-md-6">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-success rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-simplybuilt highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark"> دستگاه کالیبراسیون آزمایشگاه </p>
                            <h5>{{outlocation_amount}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-warning rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-simplybuilt highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark"> دستگاه کالیبراسیون محل مشتری </p>
                            <h5>{{inlocation_amount}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mb-30">

                  <div class="col-md-6">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-danger rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-certificate highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark"> گواهی‌نامه تحویل شده آزمایشگاه</p>
                            <h5>{{outlocation_certificate}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-info rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-certificate highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark"> گواهی‌نامه تحویل شده محل مشتری </p>
                            <h5>{{inlocation_certificate}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="row mb-30">

                  <div class="col-md-4">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-success rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-file-powerpoint-o highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark"> امتیاز تحویل گواهی‌نامه زودتر از طرح</p>
                            <h5>{{tajil_point}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-info rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-file-powerpoint-o highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark"> امتیاز تحویل گواهی‌نامه برابر با طرح</p>
                            <h5>{{barabar_point}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-danger rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-file-powerpoint-o highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark"> امتیاز تحویل گواهی‌نامه تاخیر از طرح</p>
                            <h5 style="direction: ltr;">{{takhir_point}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>


              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card card-statistics" style="margin-top: 5px;">
        <div class="card-body">
          <div class="tab nav-border" style="position: relative;">
            <div class="d-block d-md-flex justify-content-between">
              <div class="d-block w-100">
                <h5 class="card-title">گزارش گردش مالی کاربری</h5>
              </div>
              <div class="d-block d-md-flex nav-tabs-custom">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active show" routerLink="/FundsUser"> جزئیات </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="tab-content">
              <div class="tab-pane fade active show">
                <div class="row mb-30">
                  <div class="col-md-4">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-info rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-download highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark"> واریزی (ريال)</p>
                            <h5>{{funds_Recive | number}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-danger rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-upload highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark">هزینه (ريال)</p>
                            <h5>{{funds_Pay | number}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-success rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-database highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark">موجودی (ريال)</p>
                            <h5>{{funds_Has | number}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>



              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card card-statistics" style="margin-top: 5px;">
        <div class="card-body">
          <div class="tab nav-border" style="position: relative;">
            <div class="d-block d-md-flex justify-content-between">
              <div class="d-block w-100">
                <h5 class="card-title">پیشنهادات</h5>
              </div>

            </div>
            <div class="tab-content">
              <div class="tab-pane fade active show">
                <div class="row mb-30">

                  <div class="col-md-4">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-info rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-leanpub highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark">تعداد پیشنهاد</p>
                            <h5>{{amount_Suggest}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-danger rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-leanpub highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark">مجموع امتیازات</p>
                            <h5>{{point_Suggest}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-success rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-leanpub highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark">تعداد روز گذشته از آخرین پیشنهاد</p>
                            <h5>{{last_Suggest}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="MyType==1" class="row mb-30">

                  <div class="col-md-6">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-danger rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-leanpub highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark">تعداد پیشنهاد منتظر</p>
                            <h5>{{waitting_Suggest}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="card card-statistics h-100">
                      <div class="card-body">
                        <div class="clearfix">
                          <div class="float-left icon-box bg-success rounded-circle">
                            <span class="text-white">
                              <i class="fa fa-leanpub highlight-icon" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div class="float-right text-right">
                            <p class="card-text text-dark">تعداد پیشنهادات بررسی شده</p>
                            <h5>{{submited_Suggest}} </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>

  <div *ngIf="pmUser==1">
    <div class="card card-statistics">
      <div class="card-body">
        <div class="tab nav-border" style="position: relative;">
          <div class="d-block d-md-flex justify-content-between">
            <div class="d-block w-100">
              <h5 class="card-title">گزارش سرویس های PM</h5>
            </div>
            <div class="d-block d-md-flex nav-tabs-custom">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active show" id="todayService-tab" data-toggle="tab" href="#todayService"
                    role="tab" aria-controls="todayService" aria-selected="true">امروز</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="weekService-tab" data-toggle="tab" href="#weekService" role="tab"
                    aria-controls="weekService">هفته آینده</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="monthService-tab" data-toggle="tab" href="#monthService" role="tab"
                    aria-controls="year" aria-selected="false">ماه آینده</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="unstartService-tab" data-toggle="tab" href="#unstartService" role="tab"
                    aria-controls="year" aria-selected="false">شروع نشده</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade active show" id="todayService" role="tabpanel" aria-labelledby="todayService-tab">
              <div class="row mb-30">

                <div class="table-responsive">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">
                    <thead style="background-color: #489b39; color: white;">
                      <tr>
                        <th>#</th>
                        <th>برنامه</th>
                        <th>تاریخ قبلی</th>
                        <th>تاریخ بعدی</th>
                        <th>Description</th>
                        <th>Manufacturer</th>
                        <th>Model</th>
                        <th>Code BEHFA</th>
                        <th>ایجاد کننده</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of today_PM_DataList|
                       paginate : {
                          id: 'DataList_PMTable',
                          itemsPerPage: 5,
                          currentPage: today_PM_DataList_page,
                          totalItems: today_PM_DataList.length
                        }
                        ">
                        <td>{{today_PM_DataList.indexOf(item)+1}}</td>
                        <td>{{item.title}}</td>
                        <td>{{item.base_date}}</td>
                        <td>{{item.next_date}}</td>
                        <td>{{item.deviceBehfa.description}}</td>
                        <td>{{item.deviceBehfa.manufacturer}}</td>
                        <td>{{item.deviceBehfa.model}}</td>
                        <td>{{item.deviceBehfa.codeBEHFA}}</td>
                        <td>{{item.username}}</td>

                      </tr>
                    </tbody>
                  </table>
                </div>
                <pagination-controls id="DataList_PMTable" nextLabel="بعدی" previousLabel="قبلی"
                  (pageChange)="today_PM_DataList_page = $event"></pagination-controls>

              </div>

            </div>

            <div class="tab-pane fade" id="weekService" role="tabpanel" aria-labelledby="weekService-tab">
              <div class="row mb-30">

                <div class="table-responsive">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">
                    <thead style="background-color: #489b39; color: white;">
                      <tr>
                        <th>#</th>
                        <th>برنامه</th>
                        <th>تاریخ قبلی</th>
                        <th>تاریخ بعدی</th>
                        <th>Description</th>
                        <th>Manufacturer</th>
                        <th>Model</th>
                        <th>Code BEHFA</th>
                        <th>ایجاد کننده</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of week_PM_DataList|
                       paginate : {
                          id: 'DataList_PMTableWeek',
                          itemsPerPage: 5,
                          currentPage: week_PM_DataList_page,
                          totalItems: week_PM_DataList.length
                        }
                        ">
                        <td>{{week_PM_DataList.indexOf(item)+1}}</td>
                        <td>{{item.title}}</td>
                        <td>{{item.base_date}}</td>
                        <td>{{item.next_date}}</td>
                        <td>{{item.deviceBehfa.description}}</td>
                        <td>{{item.deviceBehfa.manufacturer}}</td>
                        <td>{{item.deviceBehfa.model}}</td>
                        <td>{{item.deviceBehfa.codeBEHFA}}</td>
                        <td>{{item.username}}</td>

                      </tr>
                    </tbody>
                  </table>
                </div>
                <pagination-controls id="DataList_PMTableWeek" nextLabel="بعدی" previousLabel="قبلی"
                  (pageChange)="week_PM_DataList_page = $event"></pagination-controls>

              </div>

            </div>

            <div class="tab-pane fade" id="monthService" role="tabpanel" aria-labelledby="monthService-tab">
              <div class="row mb-30">
                <div class="table-responsive">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">
                    <thead style="background-color: #489b39; color: white;">
                      <tr>
                        <th>#</th>
                        <th>برنامه</th>
                        <th>تاریخ قبلی</th>
                        <th>تاریخ بعدی</th>
                        <th>Description</th>
                        <th>Manufacturer</th>
                        <th>Model</th>
                        <th>Code BEHFA</th>
                        <th>ایجاد کننده</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of DataList_PMTableMonth|
                       paginate : {
                          id: 'DataList_PMTableWeek',
                          itemsPerPage: 5,
                          currentPage: month_PM_DataList_page,
                          totalItems: month_PM_DataList.length
                        }
                        ">
                        <td>{{month_PM_DataList.indexOf(item)+1}}</td>
                        <td>{{item.title}}</td>
                        <td>{{item.base_date}}</td>
                        <td>{{item.next_date}}</td>
                        <td>{{item.deviceBehfa.description}}</td>
                        <td>{{item.deviceBehfa.manufacturer}}</td>
                        <td>{{item.deviceBehfa.model}}</td>
                        <td>{{item.deviceBehfa.codeBEHFA}}</td>
                        <td>{{item.username}}</td>

                      </tr>
                    </tbody>
                  </table>
                </div>
                <pagination-controls id="DataList_PMTableMonth" nextLabel="بعدی" previousLabel="قبلی"
                  (pageChange)="month_PM_DataList_page = $event"></pagination-controls>
              </div>

            </div>

            <div class="tab-pane fade" id="unstartService" role="tabpanel" aria-labelledby="unstartService-tab">
              <div class="row mb-30">
                <div class="table-responsive">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">
                    <thead style="background-color: #489b39; color: white;">
                      <tr>
                        <th>#</th>
                        <th>برنامه</th>
                        <th>تاریخ قبلی</th>
                        <th>تاریخ بعدی</th>
                        <th>Description</th>
                        <th>Manufacturer</th>
                        <th>Model</th>
                        <th>Code BEHFA</th>
                        <th>ایجاد کننده</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of unstart_PM_DataList|
                       paginate : {
                          id: 'DataList_PMTableUnstart',
                          itemsPerPage: 5,
                          currentPage: unstart_PM_DataList_page,
                          totalItems: unstart_PM_DataList.length
                        }
                        ">
                        <td>{{unstart_PM_DataList.indexOf(item)+1}}</td>
                        <td>{{item.title}}</td>
                        <td>{{item.base_date}}</td>
                        <td>{{item.next_date}}</td>
                        <td>{{item.deviceBehfa.description}}</td>
                        <td>{{item.deviceBehfa.manufacturer}}</td>
                        <td>{{item.deviceBehfa.model}}</td>
                        <td>{{item.deviceBehfa.codeBEHFA}}</td>
                        <td>{{item.username}}</td>

                      </tr>
                    </tbody>
                  </table>
                </div>
                <pagination-controls id="DataList_PMTableUnstart" nextLabel="بعدی" previousLabel="قبلی"
                  (pageChange)="unstart_PM_DataList_page = $event"></pagination-controls>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div style="margin-top: 50px;" class="row" *ngIf="type_DeviceBehfa==1 && !Procssing">
    <div class="col-md-4" (click)="exportexcel_two_Month_DeviceBehfa()">
      <div class="card card-statistics h-100">
        <div class="card-body">
          <div class="clearfix">
            <div class="float-left icon-box bg-info rounded-circle">
              <span class="text-white">
                <i class="fa fa-building highlight-icon" aria-hidden="true"></i>
              </span>
            </div>
            <div class="float-right text-right">
              <p class="card-text text-dark"> تجهیزات بهفا <b>دو ماه مانده به انقضاء</b> </p>
              <h4>{{two_Month_DeviceBehfa.length}}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4" (click)="exportexcel_one_Month_DeviceBehfa()">
      <div class="card card-statistics h-100">
        <div class="card-body">
          <div class="clearfix">
            <div class="float-left icon-box bg-warning rounded-circle">
              <span class="text-white">
                <i class="fa fa-building highlight-icon" aria-hidden="true"></i>
              </span>
            </div>
            <div class="float-right text-right">
              <p class="card-text text-dark"> تجهیزات بهفا <b>یک ماه مانده به انقضاء</b> </p>
              <h4>{{one_Month_DeviceBehfa.length}}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4" (click)="exportexcel_zero_Month_DeviceBehfa()">
      <div class="card card-statistics h-100">
        <div class="card-body">
          <div class="clearfix">
            <div class="float-left icon-box bg-danger rounded-circle">
              <span class="text-white">
                <i class="fa fa-building highlight-icon" aria-hidden="true"></i>
              </span>
            </div>
            <div class="float-right text-right">
              <p class="card-text text-dark"> تعداد تجهیزات بهفا <b>منقضی شده</b> </p>
              <h4>{{zero_Month_DeviceBehfa.length}}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>




  <table id="excel-table_two_Month_DeviceBehfa" style="display: none;">
    <thead>
      <tr>
        <th>#</th>
        <th>Group</th>
        <th>Description</th>
        <th>Manufacturer</th>
        <th>Model</th>
        <th>Code BEHFA</th>
        <th>Certificate No.</th>
        <th>Cal. Due</th>
        <th>وضیعت</th>
        <th>تاریخ</th>
        <th>کاربر</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of two_Month_DeviceBehfa">
        <td>{{two_Month_DeviceBehfa.indexOf(item)+1}}</td>
        <td>{{item.groupTitle}}</td>
        <td class="EnglishClm">{{item.description}}</td>
        <td class="EnglishClm">{{item.manufacturer}}</td>
        <td class="EnglishClm">{{item.model}}</td>
        <td class="EnglishClm">{{item.codeBEHFA}}</td>
        <td class="EnglishClm">{{item.certificateNo}}</td>
        <td>
          <p *ngIf="item.status==1" style="color: #489b39;">فعال</p>
          <p *ngIf="item.status==2" style="color: crimson;">غیر فعال</p>
          <p *ngIf="item.status==3" style="color: mediumblue;">در حال تعمیر</p>
          <p *ngIf="item.status==4" style="color: gold;">در حال کالیبراسیون</p>
          <p *ngIf="item.status==5" style="color:rgb(255, 5, 5);">غیر فعال دائم</p>

        </td>
        <td>{{item.persianDate}}</td>
        <td>{{item.username}} </td>
      </tr>
    </tbody>
  </table>

  <table id="excel-table_one_Month_DeviceBehfa" style="display: none;">
    <thead>
      <tr>
        <th>#</th>
        <th>Group</th>
        <th>Description</th>
        <th>Manufacturer</th>
        <th>Model</th>
        <th>Code BEHFA</th>
        <th>Certificate No.</th>
        <th>Cal. Due</th>
        <th>وضیعت</th>
        <th>تاریخ</th>
        <th>کاربر</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of one_Month_DeviceBehfa">
        <td>{{one_Month_DeviceBehfa.indexOf(item)+1}}</td>
        <td>{{item.groupTitle}}</td>
        <td class="EnglishClm">{{item.description}}</td>
        <td class="EnglishClm">{{item.manufacturer}}</td>
        <td class="EnglishClm">{{item.model}}</td>
        <td class="EnglishClm">{{item.codeBEHFA}}</td>
        <td class="EnglishClm">{{item.certificateNo}}</td>
        <td>
          <p *ngIf="item.status==1" style="color: #489b39;">فعال</p>
          <p *ngIf="item.status==2" style="color: crimson;">غیر فعال</p>
          <p *ngIf="item.status==3" style="color: mediumblue;">در حال تعمیر</p>
          <p *ngIf="item.status==4" style="color: gold;">در حال کالیبراسیون</p>
          <p *ngIf="item.status==5" style="color:rgb(255, 5, 5);">غیر فعال دائم</p>

        </td>
        <td>{{item.persianDate}}</td>
        <td>{{item.username}} </td>
      </tr>
    </tbody>
  </table>


  <table id="excel-table_zero_Month_DeviceBehfa" style="display: none;">
    <thead>
      <tr>
        <th>#</th>
        <th>Group</th>
        <th>Description</th>
        <th>Manufacturer</th>
        <th>Model</th>
        <th>Code BEHFA</th>
        <th>Certificate No.</th>
        <th>Cal. Due</th>
        <th>وضیعت</th>
        <th>تاریخ</th>
        <th>کاربر</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of zero_Month_DeviceBehfa">
        <td>{{zero_Month_DeviceBehfa.indexOf(item)+1}}</td>
        <td>{{item.groupTitle}}</td>
        <td class="EnglishClm">{{item.description}}</td>
        <td class="EnglishClm">{{item.manufacturer}}</td>
        <td class="EnglishClm">{{item.model}}</td>
        <td class="EnglishClm">{{item.codeBEHFA}}</td>
        <td class="EnglishClm">{{item.certificateNo}}</td>
        <td>
          <p *ngIf="item.status==1" style="color: #489b39;">فعال</p>
          <p *ngIf="item.status==2" style="color: crimson;">غیر فعال</p>
          <p *ngIf="item.status==3" style="color: mediumblue;">در حال تعمیر</p>
          <p *ngIf="item.status==4" style="color: gold;">در حال کالیبراسیون</p>
          <p *ngIf="item.status==5" style="color:rgb(255, 5, 5);">غیر فعال دائم</p>

        </td>
        <td>{{item.persianDate}}</td>
        <td>{{item.username}} </td>
      </tr>
    </tbody>
  </table>

</div>

<div *ngIf="MyType==3 || MyType==4">

  <!-- widgets -->
  <div class="row">
    <div class="col-xl-3 col-lg-6 col-md-6 mb-30">
      <div class="card card-statistics h-100">
        <div class="card-body">
          <div class="clearfix">
            <div class="float-left">
              <span class="text-danger">
                <i class="fa  fa-paper-plane-o highlight-icon" aria-hidden="true"></i>
              </span>
            </div>
            <div class="float-right text-right">
              <p class="card-text text-dark">درخواست کالیبراسیون</p>
              <h4>{{Calibration_Customer|number}}</h4>
            </div>
          </div>
          <p class="text-muted pt-3 mb-0 mt-2 border-top">
            <i class="fa fa-check mr-1" aria-hidden="true"></i> نامه های تایید شده
          </p>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-md-6 mb-30">
      <div class="card card-statistics h-100">
        <div class="card-body">
          <div class="clearfix">
            <div class="float-left">
              <span class="text-warning">
                <i class="fa  fa-simplybuilt highlight-icon" aria-hidden="true"></i>
              </span>
            </div>
            <div class="float-right text-right">
              <p class="card-text text-dark">تجهیزات</p>
              <h4>{{(Calibration_Customer_Device_InLocation+Calibration_Customer_Device_NotLocation)|number}}</h4>
            </div>
          </div>
          <p class="text-muted pt-3 mb-0 mt-2 border-top">
            <i class="fa fa-info mr-1" aria-hidden="true"></i>تجهیزات کالیبه شده
          </p>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-md-6 mb-30">
      <div class="card card-statistics h-100">
        <div class="card-body">
          <div class="clearfix">
            <div class="float-left">
              <span class="text-success">
                <i class="fa fa-flask highlight-icon" aria-hidden="true"></i>
              </span>
            </div>
            <div class="float-right text-right">
              <p class="card-text text-dark">در محل مشتری</p>
              <h4>{{Calibration_Customer_Device_InLocation|number}} </h4>
            </div>
          </div>
          <p class="text-muted pt-3 mb-0 mt-2 border-top">
            <i class="fa fa-calendar mr-1" aria-hidden="true"></i> تجهیزات کالیبه شده در محل مشتری
          </p>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-md-6 mb-30">
      <div class="card card-statistics h-100">
        <div class="card-body">
          <div class="clearfix">
            <div class="float-left">
              <span class="text-primary">
                <i class="fa fa-paste highlight-icon" aria-hidden="true"></i>
              </span>
            </div>
            <div class="float-right text-right">
              <p class="card-text text-dark">آزمایشگاه بهینه</p>
              <h4>{{Calibration_Customer_Device_NotLocation|number}}</h4>
            </div>
          </div>
          <p class="text-muted pt-3 mb-0 mt-2 border-top">
            <i class="fa fa-repeat mr-1" aria-hidden="true"></i> تجهیزات کالیبه شده در آزمایشگاه بهینه
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-4 mb-30">
      <div class="card card-statistics h-100">
        <div class="p-4 text-center bg-danger">
          <h5 class="mb-70 text-white">پروفایل</h5>
        </div>
        <div class="card-body text-center">
          <div class="avatar-top">
            <img class="img-fluid w-25 rounded-circle " src="{{BaserUrlImage}}" alt="">
          </div>
          <p class="mt-30">{{Fullname}}</p>
          <p class="mt-30" *ngIf="MyType">{{MyCustomerName}}</p>

          <div class="social-icons color-icon mt-20">
            <ul>
              <li class="social-rss"><a href="#"><i class="fa fa-rss"></i></a></li>
              <li class="social-facebook"><a href="#"><i class="fa fa-facebook"></i></a></li>
              <li class="social-twitter"><a href="#"><i class="fa fa-twitter"></i></a></li>
              <li class="social-github"><a href="#"><i class="fa fa-github"></i></a></li>
              <li class="social-youtube"><a href="#"><i class="fa fa-youtube"></i></a></li>
              <li class="social-instagram"><a href="#"><i class="fa fa-instagram"></i></a></li>
            </ul>
          </div>
          <div class="divider mt-20"></div>
        </div>
      </div>
    </div>

    <div class="col-xl-8 mb-30">
      <div class="card card-statistics h-100">
        <div class="card-body">
          <h5 class="card-title pb-0 mb-15 border-0"> نمایندگان فعال '{{MyCustomerName}}' </h5>
          <div class="table-responsive">
            <table class="table center-aligned-table mb-0">
              <thead>
                <tr class="text-dark">
                  <th></th>
                  <th>کاربر</th>
                  <th>نام</th>
                  <th>نام خانوادگی</th>


                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of Customer_User">
                  <td>{{Customer_User.indexOf(item)+1}}</td>
                  <td>{{item.codeMeli}}</td>
                  <td>{{item.fname}}</td>
                  <td>{{item.lname}}</td>

                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="row">
    <div class="col-md-12">
      <app-AzmoonMaharatRequestCalender></app-AzmoonMaharatRequestCalender>
    </div>
  </div>


</div>

<app-AlertUserList [hidden]="Switch_Alert_Form=='Hidden'" (OnBack_Alert_Action)="set_Switch_Alert_Form($event)">

</app-AlertUserList>